export type ActionType =
  | 'SET_DESTINATION_DATA'
  | 'REQUEST_DESTINATION_DATA'
  | 'RECEIVED_DESTINATION_DATA'
  | 'ERROR_DESTINATION_DATA';

interface ActionProps {
  type: ActionType;
  isFetching?: boolean;
  data?: {} | any;
  error?: any;
  payload?: {} | any;
}

const initialDestinationState = {
  isFetching: true,
  data: {},
  error: {},
};

const Destination = (
  state = initialDestinationState,
  action: Partial<ActionProps>,
) => {
  switch (action.type) {
    case 'REQUEST_DESTINATION_DATA': {
      return {
        ...state,
        isFetching: true,
      };
    }

    case 'RECEIVED_DESTINATION_DATA': {
      const { payload = {} } = action;
      return {
        ...state,
        isFetching: false,
        data: { ...payload },
      };
    }

    case 'ERROR_DESTINATION_DATA': {
      const { error = {} } = action;
      return {
        ...state,
        isFetching: false,
        error: { ...error },
      };
    }

    default:
      return state;
  }
};

export default Destination;
